import { FC } from 'react';

export const EmptyMsg: FC = ({ children }) => {
  if (typeof children === 'string') {
    return <p className='text-sm font-medium text-gray-400 italic text-center py-8'>{children}</p>;
  }
  return <>{children}</>;
};
